<template>
    <div id="gallery"
         :class="{activeImage: activeImage}"
         @keyup="handleKeyboard">
        <h1 class="mb-4 py-4 text-center">{{ eng ? 'Gallery' : 'Galería' }}</h1>

        <div class="container" @click="openImage">
            <div class="mb-3 d-sm-flex">
                <div class="square mr-3 d-flex align-items-center">
                    <div class="col-md-3">
                        <h1>{{ eng ? 'Our Civil Work' : 'Nuestras Obras Civiles' }}</h1>
                    </div>
                </div>

                <div class="square mr-3">
                    <img src="/static/civic/gallery01.jpg" alt="">
                </div>

                <div class="square">
                    <img src="/static/civic/gallery02.jpg" alt="">
                </div>
            </div>

            <div class="d-sm-flex mb-3">
                <div class="square mr-3 d-flex align-items-center">
                    <img src="/static/civic/gallery03.jpg" alt="">
                </div>

                <div class="square mr-3">
                    <img src="/static/civic/gallery04.jpg" alt="">
                </div>

                <div class="square">
                    <img src="/static/civic/gallery05.jpg" alt="">
                </div>
            </div>

            <div class="d-sm-flex mb-3">
                <div class="square mr-3 d-flex align-items-center">
                    <img src="/static/civic/gallery06.jpg" alt="">
                </div>

                <div class="square mr-3">
                    <img src="/static/civic/gallery07.jpg" alt="">
                </div>

                <div class="square">
                    <img src="/static/civic/gallery08.jpg" alt="">
                </div>
            </div>

            <div class="d-sm-flex mb-3">
                <div class="square mr-3 d-flex align-items-center">
                    <img src="/static/civic/gallery09.jpg" alt="">
                </div>

                <div class="square mr-3">
                    <img src="/static/civic/gallery10.jpg" alt="">
                </div>

                <div class="square">
                    <img src="/static/civic/gallery11.jpg" alt="">
                </div>
            </div>

            <div class="d-sm-flex mb-3">
                <div class="square mr-3 d-flex align-items-center">
                    <img src="/static/civic/gallery12.jpg" alt="">
                </div>

                <div class="square mr-3">
                    <img src="/static/civic/gallery13.jpg" alt="">
                </div>

                <div class="square">
                    <img src="/static/civic/gallery14.jpg" alt="">
                </div>
            </div>

            <div class="d-sm-flex">
                <div class="square mr-3 d-flex align-items-center">
                    <img src="/static/civic/gallery15.jpg" alt="">
                </div>

                <div class="square mr-3">
                    <img src="/static/civic/gallery16.jpg" alt="">
                </div>

                <div class="square">
                    <img src="/static/civic/gallery17.jpg" alt="">
                </div>
            </div>

            <div class="d-sm-flex mb-3 mt-6">
                <div class="square mr-3 d-flex align-items-center">
                    <div class="col-md-3">
                        <h1>{{ eng ? 'Our Antennas Work' : 'Nuestras Obras de Antenas' }}</h1>
                    </div>
                </div>

                <div class="square mr-3">
                    <img src="/static/antennas/gallery01.jpg" alt="">
                </div>

                <div class="square">
                    <img src="/static/antennas/gallery02.jpg" alt="">
                </div>
            </div>

            <div class="d-sm-flex mb-3">
                <div class="square mr-3 d-flex align-items-center">
                    <img src="/static/antennas/gallery03.jpg" alt="">
                </div>

                <div class="square mr-3">
                    <img src="/static/antennas/gallery04.jpg" alt="">
                </div>

                <div class="square">
                    <img src="/static/antennas/gallery05.jpg" alt="">
                </div>
            </div>

            <div class="d-sm-flex mb-3">
                <div class="square mr-3 d-flex align-items-center">
                    <img src="/static/antennas/gallery06.jpg" alt="">
                </div>

                <div class="square mr-3">
                    <img src="/static/antennas/gallery07.jpg" alt="">
                </div>

                <div class="square">
                    <img src="/static/antennas/gallery08.jpg" alt="">
                </div>
            </div>
        </div>

        <div class="lightbox" v-show="activeImage">
            <div class="content justify-content-center d-flex">
                <img :src="activeImage" alt="">
            </div>

            <a href="javascript:void(0)"
               title="select to close this image"
               @click="closeImage"
               class="close-button"><i class="fas fa-times"></i>
            </a>

            <a href="javascript:void(0)"
               title="select to close this image"
               @click="goToPrevious"
               class="prev-button"><i class="fas fa-chevron-left"></i>
            </a>

            <a href="javascript:void(0)"
               title="select to close this image"
               @click="goToNext"
               class="next-button"><i class="fas fa-chevron-right"></i>
            </a>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Gallery',

    created () {
      document.addEventListener('keyup', this.handleKeyboard)
    },

    data () {
      return {
        activeImage: false
      }
    },

    destroyed () {
      document.removeEventListener('keyup', this.handleKeyboard)
    },

    methods: {
      closeImage () {
        this.activeImage = false
      },

      goToNext () {
        let base = this.activeImage.slice(0, -6)
        let limit = base.includes('civic') ? 16 : 7
        let current = Number(this.activeImage.slice(-6).replace('.jpg', ''))
        let next = current > limit ? 1 : current + 1
        next = `0${next}`.slice(-2)

        this.activeImage = `${base}${next}.jpg`
      },

      goToPrevious () {
        let base = this.activeImage.slice(0, -6)
        let limit = base.includes('civic') ? 16 : 7
        let current = Number(this.activeImage.slice(-6).replace('.jpg', ''))
        let previous = current < 2 ? limit + 1 : current - 1
        previous = `0${previous}`.slice(-2)

        this.activeImage = `${base}${previous}.jpg`
      },

      handleKeyboard () {
        if (!this.activeImage) return

        let { keyCode } = event

        if (keyCode === 27) this.closeImage()
        else if (keyCode === 37) this.goToPrevious()
        else if (keyCode === 39) this.goToNext()
        else console.log('key code', keyCode)
      },

      openImage () {
        let { target } = event
        if (target.tagName !== 'IMG') return
        this.activeImage = target.src
      }
    },

    props: ['eng']
  }
</script>

<style lang="sass" scoped>
#gallery
    padding-top: 50px
    padding-bottom: 150px
    &.activeImage
        overflow: hidden
        max-height: 0

    .mt-6
        margin-top: 120px

.lightbox
    position: fixed
    top: 0
    left: 0
    width: 100vw
    height: 100vh
    z-index: 9
    background-color: rgba(255, 255, 255, 0.98)

    .close-button
        position: absolute
        top: 20px
        right: 30px
        font-size: 30px

    .content
        height: 80vh
        width: 80vw
        margin: 10vh 10vw
        overflow: hidden

        img
            max-height: 100%

    .prev-button
        position: absolute
        top: 50%
        left: 30px
        font-size: 30px

    .next-button
        position: absolute
        top: 50%
        right: 30px
        font-size: 30px

.square
    background-color: white
    height: 340px
    width: 33%
    border: 2px solid #e3e3e3
    border-radius: 5px
    overflow: hidden

    &.last
        width: calc(33% - 6px)

    img
        min-height: 100%

@media (max-width: 1024px)
    .square
        height: 280px

@media (max-width: 768px)
    #gallery
        .square
            height: 200px

@media (max-width: 736px)
    #gallery
        .square
            height: 170px

            h1
                font-size: 30px



@media (max-width: 414px)
    #gallery
        .lightbox
            .content
                img
                    max-height: none
                    object-fit: contain

        .square
            width: calc(100vw - 30px)
            height: calc(100vw - 70px)
            margin-bottom: 10px
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue